export default __webpack_public_path__ + "files/BBM1.pdf";